<template>
  <v-container fluid>
    <WriterProfile
      :user-id="`${this.$route.params.id}`"
      :allowed-keys="allowedKeys"
    />
  </v-container>
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import WriterProfile from '@/components/commons/WriterProfile'

export default {
  components: { WriterProfile },
  mixins: [headUtilsMixin],
  data () {
    return {
      pageTitle: 'ライタープロフィール設定',
      userId: `${this.$route.params.id}`,
      allowedKeys: [
        'id',
        'name',
        'title',
        'avatar',
        'introduction',
        'profileLinks',
        'writerPagePublished'
      ]
    }
  }
}
</script>
